<template>
  <div>
    <div class="img-container">
      <img src="../../public/images/c.jpeg" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'schoolCommonImage'
  }
</script>

<style lang="scss" scoped>
.img-container {
  height: 60px;
}
.img-container img {
  height: 100%;
  width: 100%;
}
</style>
